export const foo = (): void => {};

export const isRequireEGD = (code: string): boolean => {
  if (code.length !== 5) return false;
  const charAt2 = code.charAt(1);
  return charAt2 === 'C';
};
